var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Tab.styles.scss';
import { Tabs } from 'antd';
var TabPane = Tabs.TabPane;
var Tab = function (_a) {
    var tabItems = _a.tabItems, onChange = _a.onChange, activeKey = _a.activeKey, _b = _a.tabPosition, tabPosition = _b === void 0 ? 'top' : _b, _c = _a.fixed, fixed = _c === void 0 ? false : _c;
    return (_jsx("div", __assign({ className: "hefesto-tab hefesto-tab--".concat(tabPosition, " ").concat(fixed ? 'hefesto-tab--fixed' : 'hefesto-tab--no-fixed'), "data-testid": "hefesto-tab" }, { children: _jsx(Tabs, __assign({ className: "hefesto-tab__frame", onChange: onChange, activeKey: activeKey, tabPosition: tabPosition }, { children: tabItems === null || tabItems === void 0 ? void 0 : tabItems.map(function (item) {
                return (_jsx(TabPane, __assign({ tab: _jsxs("div", __assign({ className: "hefesto-tab__content" }, { children: [_jsx("span", __assign({ className: "hefesto-tab__frame-icon" }, { children: item.icon })), item.name && (_jsx("span", __assign({ className: "hefesto-tab__name" }, { children: item.name })))] })) }, { children: activeKey === item.key && _jsx(_Fragment, { children: item.content }) }), item.key));
            }) })) })));
};
export default Tab;
